type FilterProviderData = {
  value: number;
  label: string;
};

export const filterProvider: FilterProviderData[] = [
  { value: 1, label: 'Últimos 30 dias' },
  { value: 3, label: 'Últimos 3 meses' },
  { value: 6, label: 'Últimos 6 meses' },
  { value: 9, label: 'Últimos 9 meses' },
  { value: 12, label: 'Últimos 12 meses' },
];
